var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSafe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_16829",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.117188H16V19.399H0V0.117188Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_16829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 1.56093L15.9202 1.53153C10.8111 -0.354259 5.18902 -0.354259 0.0798971 1.53153L0 1.56093L0.0600203 1.58028H0L0.66529 12.3638C0.737782 13.4537 1.28381 14.4581 2.16151 15.1166L7.76483 19.3208C7.90397 19.4252 8.09611 19.4252 8.23486 19.3208L13.8386 15.1166C14.7163 14.4581 15.2623 13.4537 15.3348 12.3638L16.0001 1.58028H15.9401L16.0001 1.56093Z",
    fill: "#4DD082"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3919 7.77164C11.3457 7.63341 11.2122 7.54113 11.0607 7.54711C11.0607 7.54711 9.72851 7.55832 9.39998 7.54711C9.26419 7.54262 9.15032 7.45109 9.10147 7.33079L8.51752 5.79191C8.47174 5.63724 8.37211 5.51059 8.1863 5.50947V5.50909C8.18515 5.50909 8.18477 5.50947 8.18477 5.50947C8.184 5.50947 8.184 5.50909 8.18284 5.50909V5.50947C7.99742 5.51059 7.89702 5.63724 7.85201 5.79191L7.26806 7.33079C7.21882 7.45109 7.10457 7.54262 6.96916 7.54711C6.64103 7.55832 5.30886 7.54711 5.30886 7.54711C5.1573 7.54113 5.02343 7.63341 4.97726 7.77164C4.92687 7.92258 4.99073 8.06305 5.1396 8.15758C5.1396 8.15758 6.50523 9.15772 6.50523 9.15846C6.61871 9.25299 6.63218 9.31911 6.63064 9.43867L6.62064 9.50853C6.53062 9.83581 6.2448 10.5871 6.07939 11.0123C6.02784 11.1498 6.04015 11.2962 6.1744 11.3967C6.30058 11.4886 6.47407 11.4834 6.60794 11.3769C6.60794 11.3769 7.82278 10.5576 8.02704 10.4399C8.07552 10.4123 8.13014 10.3988 8.18477 10.3955C8.23939 10.3988 8.29363 10.4123 8.3421 10.4399C8.54637 10.5576 9.7612 11.3769 9.7612 11.3769C9.89507 11.4834 10.0686 11.4886 10.1947 11.3967C10.3294 11.2962 10.3413 11.1498 10.2898 11.0123C10.1247 10.5871 9.83853 9.83581 9.74851 9.50853L9.73774 9.43867C9.73735 9.31911 9.75043 9.25299 9.86391 9.15846C9.86391 9.15772 11.2295 8.15758 11.2295 8.15758C11.3784 8.06305 11.4419 7.92258 11.3919 7.77164Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSafe);
export default __webpack_public_path__ + "static/media/icon-safe.cd7c74fb753185fff999ccf933491876.svg";
export { ForwardRef as ReactComponent };